import { render, staticRenderFns } from "./VideoList3.vue?vue&type=template&id=71b0e1a1&scoped=true"
import script from "./VideoList3.vue?vue&type=script&lang=js"
export * from "./VideoList3.vue?vue&type=script&lang=js"
import style0 from "./VideoList3.vue?vue&type=style&index=0&id=71b0e1a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b0e1a1",
  null
  
)

export default component.exports